export default {
  features: {
    cancelApplicationRequestApproval: {
      button: 'Bekor qilish',
    },
  },
};
